import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('APP', {
  FETCH_COOKIES: null,
  LOAD_APP_CONFIG: null,
  LOAD_COOKIES: null
});
